import { defineComponent as _defineComponent } from 'vue'
import {
  BaseText,
  Row,
  ButtonIconContextual
} from '@warrenbrasil/nebraska-web';
import { ProfitMonthlies } from '@/modules/wealth/services/portfolio';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { useRouter } from 'vue-router/composables';
import { Money } from '@/modules/common/components/Money';
import { WarrenSession } from '@/modules/common/services/session';
import { StorageKeys } from '@/modules/common/services/local-storage';

interface Props {
  portfolioId: string;
  year: string;
  profitData: ProfitMonthlies;
  hasDivider: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'AnnualProfitRow',
  props: {
    portfolioId: null,
    year: null,
    profitData: null,
    hasDivider: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  portfolioId: string;
  year: string;
  profitData: ProfitMonthlies;
  hasDivider: boolean;
}


const router = useRouter();
const computedClass = props.profitData.isDisabled ? ' disabled' : '';
const getTextColor = props.profitData.isDisabled
  ? NebraskaColors.textDisabled
  : '';

const goToProfitDetail = () => {
  if (props.profitData.isDisabled) return;

  WarrenSession.set(
    StorageKeys.ProfitMonthlyAmount,
    props.profitData.profitReceived.formatted,
    true
  );

  router.replace({
    name: 'wealthIndexPortfolioProfitDetail',
    params: {
      portfolioId: props.portfolioId,
      year: props.year,
      month: String(props.profitData.monthIndex)
    }
  });
};

return { __sfc: true,props, router, computedClass, getTextColor, goToProfitDetail, BaseText, Row, ButtonIconContextual, Money }
}

})